module.exports = __webpack_public_path__ + "static/img/bg-id.4ad7ca1e.webp";